import React,{useState} from "react";
import { Link } from "react-router-dom";

import bg1 from "../assets/images/bg/term-bg2.jpg"
import about from "../assets/images/about.jpg"
import cta from "../assets/images/cta.jpg"

import NavbarTwo from "../components/navbar/navbarTwo"
import ClientTwo from "../components/client/clientTwo";
import Partners from "../components/partners";
import Team from "../components/team";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";
import { HashLink } from 'react-router-hash-link';
import { scrollWithOffset } from "../utils/scrollUtils";

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css';

import {AiOutlineCheckCircle, FiAirplay, LiaReact, FiUsers,FiArrowRight} from '../assets/icons/vander'
import CountUp from 'react-countup';

export default function AboutUs(){
    return (
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>

        <section id="page-top" className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="title-heading text-center">
                            <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">Budgeting 101: Because "YOLO" Isn't a Financial Strategy</h5>
                            <small className="text-white-50 mb-1 fw-medium text-uppercase mx-auto">A survival guide for couples, new families, and anyone whose bank balance makes them question their life choices</small>
                        </div>
                    </div>
                </div>
            </div>
        </section>

<section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="section-title">
                            <div className="text-muted2">

<h4>Life Insurance Ownership in the U.S. by Demographic (2023–2024)</h4>
<p>Life insurance coverage in the U.S. has remained steady, with approximately <strong>51% of adults</strong> reporting they have some form of life insurance, either through an individual policy or workplace coverage¹. This leaves nearly <strong>49% of adults</strong> with no protection in place — contributing to an acknowledged coverage gap affecting over 100 million people¹.</p>

<p>This report examines how life insurance ownership differs by <strong>race/ethnicity</strong>, <strong>gender</strong>, and <strong>sexual identity</strong>, and provides a breakdown of the <strong>types of life insurance</strong> most commonly held. Data reflect trends over the past two years and are drawn from leading insurance and financial research organizations.</p>

<h4>Ownership by Race/Ethnicity</h4>
<p>There are significant racial and ethnic disparities in life insurance ownership. Surprisingly to some, Black Americans report the highest coverage rates of any major racial group, while Hispanic Americans have the lowest.</p>

<h5>Table 1. Life Insurance Ownership by Race/Ethnicity (2024)</h5>
<table className="table">
<thead>
<tr>
<th>Demographic Group</th>
<th>% Owning Life Insurance</th>
</tr>
</thead>
<tbody>
<tr><td>Black Americans</td><td>58%¹⁶</td></tr>
<tr><td>White Americans</td><td>52%¹⁶</td></tr>
<tr><td>Asian Americans</td><td>52%¹⁶</td></tr>
<tr><td>Hispanic Americans</td><td>43%¹⁶</td></tr>
</tbody>
</table>

<p>Black households have a long-standing cultural association with life insurance as a wealth-building and protection tool. In contrast, Hispanic ownership declined sharply between 2021 and 2022 before rebounding slightly by 2024¹⁶. Coverage among Native American communities is underreported in most national data sets, but smaller studies indicate coverage rates are likely lower than the national average³¹.</p>

<h4>Ownership by Gender</h4>
<p>A consistent and widening gender gap exists in life insurance ownership. As of 2024:</p>

<h5>Table 2. Life Insurance Ownership by Gender (2024)</h5>
<table className="table">
<thead>
<tr>
<th>Gender Identity</th>
<th>% Owning Life Insurance</th>
</tr>
</thead>
<tbody>
<tr><td>Men</td><td>57%⁶</td></tr>
<tr><td>Women</td><td>46%⁶</td></tr>
</tbody>
</table>

<p>This 11-point difference is the widest in over a decade of tracking⁶. Despite equal or greater perceived need among women, cost concerns and a lack of education on policy types remain significant barriers⁸. Additionally, slightly fewer women receive group life insurance benefits through employers than men⁶, adding to the gap in total protection.</p>

<h4>Ownership by Sexual Identity</h4>
<p>Newer research now includes LGBTQ+ consumers, who show significantly lower rates of coverage than the general population.</p>

<h5>Table 3. Life Insurance Ownership: Overall vs. LGBTQ+ (2024)</h5>
<table className="table">
<thead>
<tr>
<th>Group</th>
<th>% Owning Life Insurance</th>
</tr>
</thead>
<tbody>
<tr><td>U.S. Adults (all)</td><td>51%³</td></tr>
<tr><td>LGBTQ+ Adults</td><td>40%³</td></tr>
</tbody>
</table>

<p>In this group, 46% say they need more or any life insurance, yet many distrust insurance providers or feel a lack of representation when working with financial professionals³. Roughly 1 in 5 LGBTQ+ consumers say having an advisor who is either LGBTQ+ or an ally is one of their top priorities³.</p>

<h4>Ownership by Type of Policy</h4>

<h5>Term Life Insurance</h5>
<p>The most common and affordable form, term life insurance, is owned by nearly 48% of U.S. households⁴¹. Term coverage accounts for only 19% of new premium dollars, indicating its cost-effectiveness⁴⁰.</p>

<h5>Whole Life Insurance</h5>
<p>Whole life policies offer permanent coverage with guaranteed cash value. In 2024, whole life represented 36–37% of new life insurance premiums, and 5.8 million new whole life policies were sold¹¹. While fewer households own whole life than term, it dominates in long-term planning strategies⁴⁰.</p>

<h5>Universal Life Insurance</h5>
<p>Universal life (UL) products — including Indexed UL (IUL) and Variable UL (VUL) — offer more flexibility and market-based growth potential. Together, UL policies accounted for about 44% of new premium sales in 2024, with IUL representing 23–24%, VUL about 14–15%, and traditional fixed UL around <strong>6%</strong>⁴⁰.</p>

<h4>Ownership by Source: Employer vs. Individual Coverage</h4>
<p>In addition to understanding the type of life insurance owned, it's essential to know where coverage comes from. Many Americans hold group life insurance through their employer, while others purchase their own individual policies.</p>

<p>According to LIMRA's 2024 data:</p>

<table className="table">
<thead>
<tr>
<th>Coverage Type</th>
<th>% of U.S. Adults with Life Insurance</th>
</tr>
</thead>
<tbody>
<tr><td>Only employer-based (group) life</td><td>26%²⁶</td></tr>
<tr><td>Only privately owned policy</td><td>55%²⁶</td></tr>
<tr><td>Both group and individual coverage</td><td>19%²⁶</td></tr>
</tbody>
</table>

<p>These categories are mutually exclusive and add up to 100% of insured adults.</p>

<p>But since only about 51% of all U.S. adults have life insurance at all, these ownership types represent a smaller portion of the total population. Here's what that looks like:</p>

<h5>Table 4. Estimated Life Insurance Coverage Among All U.S. Adults (2024)</h5>
<table className="table">
<thead>
<tr>
<th>Life Insurance Status</th>
<th>% of All Adults</th>
</tr>
</thead>
<tbody>
<tr><td>No life insurance</td><td>~49%</td></tr>
<tr><td>Only employer-based group coverage</td><td>~13% (26% of 51%)</td></tr>
<tr><td>Only individually owned policy</td><td>~28% (55% of 51%)</td></tr>
<tr><td>Both group and individual coverage</td><td>~10% (19% of 51%)</td></tr>
<tr><td>Total insured adults</td><td>~51%</td></tr>
</tbody>
</table>

<p>This shows that 26% of life-insured adults — or roughly 13% of all adults — rely solely on group coverage, which is usually limited in benefit and not portable. By contrast, 28% of all adults proactively own an individual policy, offering greater flexibility, permanence, and control.</p>

<p>This highlights a major opportunity for education and outreach: millions of Americans may think they're covered, but only hold a basic employer policy that could disappear with a job change.</p>

<h4>Conclusion</h4>
<p>While half of U.S. adults have life insurance, disparities by race, gender, and sexual identity reveal major gaps in coverage:</p>

<p>Black Americans lead in ownership rates, while Hispanic and Native American populations remain underinsured¹⁶ ³¹.</p>

<p>Men outpace women by 11 percentage points, despite women recognizing a strong need for coverage⁶.</p>

<p>LGBTQ+ Americans are underserved and underinsured, though interest in protection is high³.</p>

<p>Millions rely solely on employer plans, putting their families at risk if job circumstances change²⁶.</p>

<p>Additionally, a shift toward permanent products like whole life and IUL continues to reshape the market — though term life remains the most accessible option for families. These insights present not only challenges, but a real opportunity for financial professionals and insurers to close the protection gap across every segment of the population.</p>

<h4>Sources</h4>
<ul>
<li>LIMRA and Life Happens, 2024 Insurance Barometer Study</li>
<li>LIMRA, 2023 Barometer Study Summary</li>
<li>LIMRA, LGBTQ+ Ownership and Needs Fact Sheet, 2024</li>
<li>Amalgamated Life, Life Insurance Statistics Summary, 2023–2024</li>
<li>NAIC/ACLI, Life Insurers Fact Book 2022</li>
<li>LIMRA Newsroom, U.S. Life Insurance Need Gap Widens, 2024</li>
<li>Bankrate, Life Insurance Statistics 2025</li>
<li>FinHealth Network, Understanding and Closing Life Insurance Coverage Gaps, 2024</li>
<li>ACLI, Policy Type Distribution Data, 2019–2024</li>
<li>LIMRA, Indexed UL and Whole Life Sales Reports, 2023–2024</li>
<li>American Council of Life Insurers (ACLI), Industry Sales Report, 2024</li>
<li>MoneyGeek, Life Insurance Trends and Disparities, May 2025</li>
<li>Pew Research and U.S. Census Bureau, Demographic Trends in Financial Products Access</li>
</ul>

</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <FooterThree/>
        <ScrollTop/>
         </>
    )
}